import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/components/Landing";
import PublicLanding from "@/components/PublicLanding";
import { getToken } from "@/lib/auth";
import BesoinsModule from "@/components/BesoinsModule";
import IdrModule from "@/components/idr/IdrModule";
import QicmModule from "@/components/qicm/QicmModule";
import DriversExoModule from "@/components/exo/DriversExoModule";
import DriversEntourageModule from "@/components/exo/DriversEntourageModule";
import TdahParentsModule from "@/components/tdahParents/TdahParentsModule";
import IdrEntourageModule from "@/components/idr/IdrEntourageModule";
import DepotUpload from "@/components/depot/DepotUpload";
import EmpathieModule from "@/components/empathie/EmpathieModule";
import CopeModule from "@/components/cope/CopeModule";
import CoupleModule from "@/components/couple/CoupleModule";
import ConnaisModule from "@/components/connais/ConnaisModule";
import SchemasModule from "@/components/schemas/SchemasModule";
import ProgrammeModule from "@/components/programme/ProgrammeModule";
import SuperCerveauModule from "@/components/superCerveau/SuperCerveauModule";
import { ScActivate } from "@/components/superCerveau/ScActivation";
import Diva5Module from "@/components/tdah/Diva5Module";
import GuideTdahModule from "@/components/guideTdah/GuideTdahModule";
import BoiteOutilsModule from "@/components/tdah/BoiteOutilsModule";
import SujetsModule from "@/components/sujets/SujetsModule";
import AutogratModule from "@/components/autograt/AutogratModule";
import AssqModule from "@/components/assq/AssqModule";
import ScDesignPreview from "@/components/superCerveau/ScDesignPreview";
import Conners3Module from "@/components/tdah/Conners3Module";
import PractitionerLogin from "@/components/praticien/PractitionerLogin";
import ForgotPassword from "@/components/praticien/ForgotPassword";
import Dashboard from "@/components/praticien/Dashboard";
import PatientsList from "@/components/praticien/PatientsList";
import PatientFile from "@/components/praticien/PatientFile";
import ProtectedRoute from "@/components/praticien/ProtectedRoute";
import PatientModule from "@/components/patient/PatientModule";
import InfosPratiques from "@/components/infos/InfosPratiques";

const Protected = (el) => <ProtectedRoute>{el}</ProtectedRoute>;
// Racine : accueil public sans connexion ; le praticien connecté retrouve son catalogue.
const Home = () => (getToken() ? <Landing /> : <PublicLanding />);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/design/super-cerveau" element={<ScDesignPreview />} />
          <Route path="/besoins" element={Protected(<BesoinsModule />)} />
          <Route path="/idr-50" element={Protected(<IdrModule />)} />
          <Route path="/qicm-20" element={Protected(<QicmModule />)} />
          <Route path="/drivers-exo" element={Protected(<DriversExoModule />)} />
          <Route path="/empathie" element={Protected(<EmpathieModule />)} />
          <Route path="/cope-28" element={Protected(<CopeModule />)} />
          <Route path="/besoins-couple" element={Protected(<CoupleModule />)} />
          <Route path="/connais" element={Protected(<ConnaisModule />)} />
          <Route path="/schemas-pensees" element={Protected(<SchemasModule />)} />
          <Route path="/programme-3-semaines" element={Protected(<ProgrammeModule />)} />
          <Route path="/super-cerveau" element={Protected(<SuperCerveauModule />)} />
          <Route path="/diva5" element={Protected(<Diva5Module />)} />
          <Route path="/conners3" element={Protected(<Conners3Module />)} />
          <Route path="/guide-tdah" element={Protected(<GuideTdahModule />)} />
          <Route path="/boite-outils-tdah" element={Protected(<BoiteOutilsModule />)} />
          <Route path="/sujets-therapeutiques" element={Protected(<SujetsModule />)} />
          <Route path="/autogratification" element={Protected(<AutogratModule />)} />
          <Route path="/assq" element={Protected(<AssqModule />)} />
          <Route path="/praticien" element={<PractitionerLogin />} />
          <Route path="/praticien/mot-de-passe-oublie" element={<ForgotPassword />} />
          <Route path="/praticien/tableau-de-bord" element={Protected(<Dashboard />)} />
          <Route path="/praticien/patients" element={Protected(<PatientsList />)} />
          <Route path="/praticien/patients/:id" element={Protected(<PatientFile />)} />
          <Route path="/p/drivers-entourage/:token" element={<DriversEntourageModule />} />
          <Route path="/p/tdah-parents/:token" element={<TdahParentsModule />} />
          <Route path="/p/idr-entourage/:token" element={<IdrEntourageModule />} />
          <Route path="/p/depot/:token" element={<DepotUpload />} />
          <Route path="/p/super-cerveau/a/:code" element={<ScActivate />} />
          <Route path="/p/:moduleKey" element={<PatientModule />} />
          <Route path="/infos-pratiques" element={<InfosPratiques />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
